module.exports = __webpack_public_path__ + "img/exchange-score-btn.59d67648.png";